import specialNotesApi from "@/vue/api/users/special_notes";
import municipalCooperationExistenceApi from "@/vue/api/users/municipal_cooperation_existence";

export type ConsultationAttentionFlags = {
  hasSpecialNote: boolean;
  hasMunicipalCooperationHistory: boolean;
};

export const EMPTY_CONSULTATION_ATTENTION_FLAGS: ConsultationAttentionFlags = {
  hasSpecialNote: false,
  hasMunicipalCooperationHistory: false
};

// 相談対応時の注意点（自治体連携履歴あり / 特記事項あり）の判定に必要なフラグ。
// 夜間相談 / いつでも相談 / 日中助産師相談の各カルテ画面で共通利用する。
// 通信障害等で判定に必要な情報が取得できない場合は「注意情報なし」と区別するために例外を投げる。
// 呼び出し側は catch した際に直前の表示を維持し、注意バッジを黙って消さないこと。
export const fetchConsultationAttentionFlags = async (userId: string): Promise<ConsultationAttentionFlags> => {
  const [noteResult, existenceResult] = await Promise.allSettled([
    specialNotesApi.fetchSpecialNote(userId),
    municipalCooperationExistenceApi.fetchMunicipalCooperationExistence(userId)
  ]);

  if (noteResult.status === "rejected" || existenceResult.status === "rejected") {
    throw new Error("Failed to fetch consultation attention flags");
  }

  return {
    hasSpecialNote: noteResult.value.specialNote !== "",
    hasMunicipalCooperationHistory: existenceResult.value.hasMunicipalCooperationHistory
  };
};
